"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const formik_1 = require("formik");
const lodash_1 = require("lodash");
const React = __importStar(require("react"));
const components_1 = require("@/components");
const base_form_1 = __importDefault(require("@/components/base-form"));
const buttons_1 = require("@/components/base-form/buttons");
const fields_1 = require("@/components/base-form/fields");
const form_error_1 = __importDefault(require("@/components/base-form/form-error"));
const constants_1 = __importStar(require("@/constants"));
const services_1 = require("@/helpers/services");
const api_payloads_1 = require("@/redux/api-payloads");
const field_names_1 = require("../field-names");
const schemas_1 = require("../schemas");
const section_1 = __importDefault(require("./section"));
const styles_scss_1 = __importDefault(require("./styles.scss"));
const NEW_SECTION = (programId) => ({
    program: programId,
    name: "",
    // @ts-ignore
    section_type: undefined,
    // @ts-ignore
    session_type: undefined,
    // @ts-ignore
    contents: null,
    // @ts-ignore
    order: null,
    uniqueId: lodash_1.uniqueId()
});
const ProgramEditForm = ({ program, onCancel, deleteSection }) => {
    const [sections, setSections] = React.useState([]);
    React.useEffect(() => {
        setSections((program === null || program === void 0 ? void 0 : program.sections.map((section) => (Object.assign(Object.assign({}, section), { uniqueId: lodash_1.uniqueId() })))) || []);
    }, [program]);
    const [expanded, setExpanded] = React.useState(null);
    const onDeleteSection = (data) => {
        if (data === null || data === void 0 ? void 0 : data.id) {
            deleteSection(data);
        }
        else {
            const sectionsCopy = [...sections];
            sectionsCopy.splice(data.order, 1);
            setSections(sectionsCopy);
        }
        if (expanded !== null && (data === null || data === void 0 ? void 0 : data.order) < expanded) {
            setExpanded(expanded - 1);
        }
    };
    return (React.createElement(base_form_1.default, { initialValues: program, validationSchema: schemas_1.programEditSchema, formKey: services_1.endpoints.editProgram, onSubmitPayload: api_payloads_1.editProgramPayload },
        React.createElement("div", { className: styles_scss_1.default.container },
            React.createElement("div", { className: styles_scss_1.default.header },
                React.createElement("h3", null, program === null || program === void 0 ? void 0 : program.name),
                React.createElement("div", { className: styles_scss_1.default.buttons },
                    React.createElement(components_1.Button, { variant: "ghost", title: constants_1.default.managePrograms.create.cancel, ariaLabel: constants_1.default.managePrograms.create.cancel, onClick: onCancel }),
                    React.createElement(buttons_1.SubmitButton, { title: constants_1.default.managePrograms.create.save, allowDirty: true }))),
            React.createElement("div", { className: styles_scss_1.default.form },
                React.createElement(fields_1.TextInputField, { name: field_names_1.ProgramEditFieldNames.name, label: constants_1.default.managePrograms.create.programName, placeholder: constants_1.default.managePrograms.create.programNamePlaceholder, required: true }),
                React.createElement(formik_1.Field, { type: "hidden", name: field_names_1.ProgramEditFieldNames.id }),
                React.createElement(components_1.DraggableList, { className: styles_scss_1.default.sectionsContainer, items: sections, render: (section, index) => (React.createElement(section_1.default, { section: Object.assign(Object.assign({}, section), { program: program === null || program === void 0 ? void 0 : program.id }), deleteSection: onDeleteSection, order: index, expanded: index === expanded, onExpand: () => setExpanded(index === expanded ? null : index) })), onChangeIndex: (originalIndex, newIndex) => {
                        const copied = [...sections];
                        copied.splice(originalIndex, 1);
                        copied.splice(newIndex, 0, sections[originalIndex]);
                        setSections(copied);
                        if (Math.min(...[originalIndex, newIndex]) <= expanded && expanded <= Math.max(...[originalIndex, newIndex])) {
                            setExpanded(expanded + (originalIndex < newIndex ? -1 : 1));
                        }
                    } }),
                React.createElement("div", { className: styles_scss_1.default.addButton },
                    React.createElement(components_1.Button, { variant: "transparent", ariaLabel: "add", imgUrls: {
                            default: constants_1.Images.plus,
                            selected: constants_1.Images.plus
                        }, title: constants_1.default.managePrograms.create.addNewSection, onClick: () => {
                            const newSection = NEW_SECTION(program === null || program === void 0 ? void 0 : program.id);
                            setSections([...sections, newSection]);
                            setExpanded(sections.length);
                        } }))),
            React.createElement(form_error_1.default, { className: styles_scss_1.default.formError, formKey: services_1.endpoints.editProgram }))));
};
exports.default = ProgramEditForm;
